var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-yt",
    "data-name": "icon-yt",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.3 17.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "yt-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "yt-cls-1",
    d: "M24.42,7.46a5.23,5.23,0,0,0-1-2.41A3.45,3.45,0,0,0,21,4c-3.39-.25-8.5-.25-8.5-.25h0S7.4,3.77,4,4a3.45,3.45,0,0,0-2.44,1,5.17,5.17,0,0,0-1,2.41,37,37,0,0,0-.24,3.93v1.84a37,37,0,0,0,.24,3.93,5.36,5.36,0,0,0,1,2.42,4.15,4.15,0,0,0,2.68,1c2,.19,8.26.25,8.26.25s5.11,0,8.51-.25a3.52,3.52,0,0,0,2.43-1,5.27,5.27,0,0,0,1-2.41,37.34,37.34,0,0,0,.24-3.94V11.39a37.28,37.28,0,0,0-.24-3.93ZM10,15.47V8.64l6.56,3.42Z",
    transform: "translate(-0.37 -3.77)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocYt);
export default __webpack_public_path__ + "static/media/soc-yt.bf0cbd92a63a747adc2e78129c7d5689.svg";
export { ForwardRef as ReactComponent };